if (!customElements.get("frequently-bought")) {
  customElements.define(
    "frequently-bought",
    class FrequentlyBought extends HTMLElement {
      constructor() {
        super();

        this.cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer");
        this.submitButton = this.querySelector("[data-submit-all]");
        this.submitButton.addEventListener("click", this.onSubmitAllHandler.bind(this));
        this.hideErrors = this.dataset.hideErrors === "true";
      }

      onSubmitAllHandler(evt) {
        evt.preventDefault();

        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();
        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.submitButton.querySelector(".loading__spinner")?.classList.remove("hidden");

        // Read variant IDs from data attributes (works on both product page and collection page)
        const items = Array.from(this.querySelectorAll("[data-variant-id]"))
          .filter(el => el.dataset.available !== "false")
          .map(el => ({
            id: el.dataset.variantId,
            quantity: 1,
          }));

        // Fallback: read from forms if data attributes not found (product page)
        const formItems = items.length === 0
          ? Array.from(this.querySelectorAll("form")).map((form) => {
              const formData = new FormData(form);
              return {
                id: formData.get("id"),
                quantity: parseInt(formData.get("quantity") || 1),
              };
            })
          : [];

        const finalItems = items.length > 0 ? items : formItems;

        if (finalItems.length === 0) {
          this.submitButton.removeAttribute("aria-disabled");
          this.submitButton.classList.remove("loading");
          this.submitButton.querySelector(".loading__spinner")?.classList.add("hidden");
          return;
        }

        const requestBody = { items: finalItems };

        if (this.cart) {
          requestBody.sections = this.cart.getSectionsToRender().map((section) => section.id);
          requestBody.sections_url = window.location.pathname;
          this.cart.setActiveElement(document.activeElement);
        }

        const formConfig = fetchConfig("javascript");
        formConfig.headers["X-Requested-With"] = "XMLHttpRequest";
        formConfig.headers["Content-Type"] = "application/json";
        formConfig.body = JSON.stringify(requestBody);

        fetch(routes.cart_add_url, formConfig)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);
              this.error = true;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error) {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: finalItems.map((item) => item.id),
                cartData: response,
              });

              this.submitButton.classList.remove("loading");
              if (this.cart && this.cart.classList.contains("is-empty"))
                this.cart.classList.remove("is-empty");
              this.submitButton.removeAttribute("aria-disabled");
              this.submitButton.querySelector(".loading__spinner")?.classList.add("hidden");
            }

            this.error = false;
            this.cart.renderContents(response);
          })
          .catch((e) => console.error(e));
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(".product-form__error-message");

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}